let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3IT4G")).then(() => parcelRequire('6P7Pf'));